export default theme => ({
  root: {},
  form: {},
  textField: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  formControl: {
    //margin: theme.spacing.unit * 2,
    minWidth: 120,
    width: '100%',
  },
  portletFooter: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  snackContentOk: {
    backgroundColor: theme.palette.success.dark,
    alignItems: 'center',
  },
  snackContentError: {
    backgroundColor: theme.palette.error.dark,
    alignItems: 'center',
  },
  snackContentWarning: {
    backgroundColor: theme.palette.warning.main,
    alignItems: 'center',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
    justifyContent: 'center'
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
  },
});
